import React from 'react';

interface ExcelIconProps {
    size?: number;
    className?: string;
}

const Excel: React.FC<ExcelIconProps> = ({ size = 16, className }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M2 2C2 0.895431 2.89543 0 4 0H9.17157C9.70201 0 10.2107 0.210714 10.5858 0.585786L13.4142 3.41421C13.7893 3.78929 14 4.29799 14 4.82843V14C14 15.1046 13.1046 16 12 16H4C2.89543 16 2 15.1046 2 14V2Z"
                fill="#217346"
            />
            <path d="M5 6L8 10M8 6L5 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M10 8H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M10 11H12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    );
};

export default Excel;
